<div class="page_bottom_space" id="quote-page-scroll-top">
    <div class="container-fluid border-0" id="finalQuoteDetails">
        <div class="progress-container p-4">
            <div class="step-wrapper">
            <div class="step"><img class="active-img bg-orange"  src="assets/img/image_1.png" alt="Step 1"></div>
            <div class="label">File Validation</div>
            </div>
            <div class="line filled"></div>
            <div class="step-wrapper">
            <div class="step"><img class="active-img bg-orange" src="assets/img/image _2 _w.png" alt="Step 2"></div>
            <div class="label">Board Details</div>
            </div>
            <div class="line filled"></div>
            <div class="step-wrapper">
            <div class="step"><img class="active-img bg-orange" src="assets/img/image_3_w.png" alt="Step 3"></div>
            <div class="label">Quote</div>
            </div>
            <div class="line half-filled"></div>
            <div class="step-wrapper">
            <div class="step"><img class="active-img bg-grey" src="assets/img/image_4.png" alt="Step 3"></div>
            <div class="label">Order Details</div>
            </div>
            <div class="line"></div>
            <div class="step-wrapper">
            <div class="step"><img  class="active-img bg-grey" src="assets/img/image_5.png" alt="Step 3"></div>
            <div class="label">Review & Confirm</div>
            </div>
            <div class="line"></div>
            <div class="step-wrapper">
            <div class="step"><img class="active-img bg-grey" src="assets/img/image_6.png" alt="Step 3"></div>
            <div class="label">Place order</div>
            </div>
        </div>
        <h3 class="text-center header-title page_top_space" *ngIf="this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'" > <b>Confirm Quote Request</b> </h3>
        <!-- <div class="text-center fw-b fs-4 p-2"></div> -->
        <div class="col-12 text-center" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && !commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp">
            <div class="col-8 offset-2 mt-3 mb-3" id="error-msg-sec1" style="color: red;font-size: 18px;">
                <div class="un_resolve_blink_me">
                    <b>Note: All BOM issues are not resolved. </b>
                </div>
                <div>
                    Components quote displayed in 'Final Quote' table is a budgetary price and only covers the components that do not have issues.
                </div>
                <div>
                    Click on <a (click)="openBomUnResolveList(unResolveLineItems)" class="text-info text_deco_underline cursor-pointer">Component List</a> to view the components with unresolved BOM issues.
                </div>
            </div>
        </div>
        <div class="text-center"  *ngIf="this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'">
            <p class="m-0">Thank you for requesting <span>a <b *ngIf="commonService.commonMainObj.onlyPcb"> PCB </b> <b *ngIf="!commonService.commonMainObj.onlyPcb"> PCB+Assembly </b></span> quote. Your request# is <span class="yellow-txt fw-bolder">{{commonService.commonMainObj.wqId}}</span></p>
        </div>
        <div class="col-12 text-center mt-4"  *ngIf="this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'">
            <div class="col-10 offset-1 bg_yellow">
                <div class="row p-1">
                    <b>Quote for <span>{{commonService.commonMainObj.wqId}}</span> </b>
                </div>
            </div>
        </div>
        <div class="col-12 text-center mt-4"  *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">
            <div class="col-10 offset-1 bg_yellow">
                <div class="row p-1 btn  cursor-default">
                    <b>Quote Details</b>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="mb-3">
                <div class="col-10 mt-3 offset-1 grey-border" style="padding: 15px;border-radius: 5px;">
                    <div class="row p-1">
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.userData.firstName">
                            <div class="col-10"><b>Name:</b> {{this.commonService.commonMainObj.userData.firstName}} {{this.commonService.commonMainObj.userData.lastName}} </div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.userData.registrationCompany">
                            <div class="col-10"><b>Company: </b>{{this.commonService.commonMainObj.userData.registrationCompany}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.email">
                            <div class="col-10"><b>Email :</b> {{this.commonService.commonMainObj.email}}</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.userData.phone">
                            <div class="col-10"><b>Phone :</b> {{this.commonService.commonMainObj.userData.phone}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.uploadedFilesData.filename">
                            <div class="col-10 design_file_bom_file_name"><b>Design File : </b> <span title="{{this.commonService.commonMainObj.uploadedFilesData.filename}}">{{this.commonService.commonMainObj.uploadedFilesData.filename}}</span></div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6" *ngIf="this.commonService.commonMainObj.uploadedBomFileName">
                            <div class="col-10 design_file_bom_file_name"><b>BOM File : </b> <span title="{{commonService.commonMainObj.uploadedBomFileName}}">{{this.commonService.commonMainObj.uploadedBomFileName}}</span></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">
                            <!--  (click)="orderPlaceGuest()" -->
                            <div class="col-10"><b>Part Number :</b> {{savedPartNum}}</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6">
                            <div class="col-10"><b>Revision :</b> {{savedPartRevision}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">
                            <div class="col-10"><b>Surface finish :</b> {{commonService.commonMainObj.surfaceFinish}}</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6">
                            <div class="col-10"><b>Material :</b> {{commonService.commonMainObj.material}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">
                            <div class="col-10"><b>Board Dimensions : </b>{{commonService.commonMainObj.savedBoardDimensions}}</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="col-6">
                            <div class="col-10"><b>Layers :</b> {{savedLayer}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">
                            <div class="col-10"><b>ITAR applicable : </b>{{savedItar}}</div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 mb-3" id="standard-pcb-quote-sec">
                <div class=" col-10 offset-1 grey-border" style="padding: 6px 0;border-radius: 5px">
                    <div class="col-12 px-3 mt-3 fw-bolder">Final Quote:</div>
                    <div class="col-12 p-3 justify-content-center" id="budgetaryQuoteTableSec">
                        <div class="col-sm-12">
                            <div class="table-responsive" id="budgetaryQuoteTable">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th align="center" valign="middle">LINE ITEM</th>
                                            <th align="center" valign="middle">PART# / REV</th>
                                            <th align="center" valign="middle">QUANTITY</th>
                                            <th align="center" valign="middle">TURN TIME</th>
                                            <th align="center" valign="middle">UNIT PRICE</th>
                                            <th align="center" valign="middle">LOT PRICE</th>
                                            <th align="center" valign="middle">NRE</th>
                                            <th align="center" valign="middle">ELECTRICAL TESTING</th>
                                            <th align="center" valign="middle">MISC / OTHER</th>
                                            <th align="center" valign="middle">SUBTOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody id="quote-display-tbody"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <section class="container mb-4" style="display: none;">
                        <div style="display: flex;">
                            <div class="plr-15" style="padding-top: 5px; padding-left: 0;">Electrical Testing: </div>
                            <div class="btn-group2" id="">
                                <input (click)="switchOfButtons($event, '')" type="button" class="btn btn-switch " id="electricalTestingYes" value="Yes"/>
                                <input (click)="switchOfButtons($event, '')"  type="button" class="btn btn-switch" id="electricalTestingNo" value="No" />
                            </div>
                        </div>
                    </section>
                    <section class="container" style="display: none;">
                        <div class="row">
                            <div class="col-12 p-3 justify-content-center text-center">
                                <p>If you are placing the order within the next <b>one hour</b>, we will gaurantee delivery by <b>30/09/2023</b> </p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div class="mt-4 mb-3"  *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">
            <!-- <div class="mt-4 mb-3" > -->
                <h3 class="text-center header-title"> <b>Confirm Quote Request</b> </h3>
                <div class=" col-10 offset-1 mt-4 grey-border" style="padding: 6px 0;border-radius: 5px">
                    <div class="text-center" style="padding: 20px;">
                        <p *ngIf="!commonService.commonMainObj.greaterQtyResp">This is an <b>Advanced PCB</b>(custom quote)  request and is ineligible for an instant online quote <span *ngIf="!commonService.commonMainObj.reQuoteCheck">due to following advanced specifications:</span></p>
                        <p *ngIf="commonService.commonMainObj.greaterQtyResp"> Based on quantity and complexity of your Assembly, We are unable to provide an instant online price for assembly labor. You will be redirected to Advanced PCB flow where your request will be reviewed offline. </p>
                        <p class="ofp-link" *ngIf="!commonService.commonMainObj.reQuoteCheck" (click)="openListOfSpecification(listOfSpecification)">List of advanced specifications</p>
                        <p>We need to further assess the files and specification offline to generate a quote.</p><br>
                        <p>To proceed with this request as a custom quote, provide <b><span *ngIf="!commonService.commonMainObj.greaterQtyResp">Quantity and </span>Turntime for <span *ngIf="commonService.commonMainObj.bomFileIncluded && !commonService.commonMainObj.greaterQtyResp">PCB</span><span *ngIf="!commonService.commonMainObj.bomFileIncluded && !commonService.commonMainObj.greaterQtyResp">PCB and Assembly </span> </b> <b> <span *ngIf="commonService.commonMainObj.greaterQtyResp">Assembly</span></b> and click on <b *ngIf="commonService.commonMainObj.customAssemblySelected != true">'Request for Custom Quote'</b><b *ngIf="commonService.commonMainObj.customAssemblySelected == true"> 'Proceed' <!--'Request for Custom Quote'--></b> button </p>
                        <p>Someone from our sales team will contact you shortly.</p>
                        <p *ngIf="!commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp">Else, <b>Upload New Files</b> that meet Standard PCB Specifications
                             <!-- <a class="ofp-link" target="_blank"  href="{{apiService.Pcb_Specification_URL}}">Standard PCB Specifications</a>  -->
                             or click on 'Back' button to change PCB specifications.</p><br>
                        <div><p><i>Note: Our business hours are Monday thru Friday, 8.00 AM to 5.30 PM. </i></p></div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4  brd-label" style="text-align-last: end;">
                                    <label style="margin-right:5px;"><b>Number of Boards:</b></label>
                                </div>
                                <div class="col-4 ">
                                    <input class="form-control " name="numOfBoards" id="numOfBoards"  [(ngModel)]="quoteDetailList.numOfBoards" (keyup)="changeAssemblyTurnTime(quoteDetailList.numOfBoards,$event)">
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end;">
                                    <label style="margin-right: 5px;"><b>PCB Turn-time:</b></label>
                                </div>
                                <div class="col-4 ">
                                    <select class="form-select" id="pcb-turn-time" [(ngModel)]="quoteDetailList.pcbTurnTime">
                                        <!-- <option value="1">1 day</option> -->
                                        <option value="2">2 days</option>
                                        <option value="3">3 days</option>
                                        <option value="4">4 days</option>
                                        <option value="5">5 days</option>
                                        <option value="7">7 days</option>
                                        <option value="10">2 Weeks</option>
                                        <option value="15">3 Weeks</option>
                                        <option value="20">4 Weeks</option>
                                    </select>
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3" hidden>
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end; font-size: 20px;">
                                    <label style="margin-right: 5px;"><b style="color: #09116c;">Add Assembly?</b></label>
                                </div>
                                <div class="col-4" style="margin-top: 5px;">
                                    <input type="button" class="btn btn-switch btn-gray" style="width: 80px;font-size: 14px;" id="assemblyYes" value="Yes" (click)="switchOfButtons($event, assemblyErrorModal)"/>
                                    <input type="button" class="btn btn-switch btn-green active"  style="width: 80px;font-size: 14px;" id="assemblyNo" value="No" (click)="switchOfButtons($event, '')"/>
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" *ngIf="commonService.commonMainObj.customAssemblySelected == true" >
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4  brd-label" style="text-align-last: end;">
                                    <label style="margin-right:5px;"><b>BOM File  :</b><br/><i style="font-size: 13px;">(Retrieved from uploaded file)</i></label>
                                </div>
                                <div [ngClass]="commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name ? 'col-8' : 'col-4' " >
                                    <div *ngIf="commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name">
                                        <div style="position: relative;">
                                            <div class="row">
                                                <div class="col-5">
                                                    <div class="mt-2" style="word-wrap: break-word;" *ngIf="!commonService.commonMainObj.autoUploadFileName">{{commonService.commonMainObj.uploadedFile?.name}} </div>
                                                    <div class="mt-2" style="word-wrap: break-word;" *ngIf="commonService.commonMainObj.autoUploadFileName">{{commonService.commonMainObj.autoUploadFileName}} </div>
                                                </div>
                                                <div class="col-7 p-0" style="display: inline-flex;">
                                                    <div><span class="not-bom-text" style="font-size: 13px;"><i>Not the BOM you wanted?</i></span></div>
                                                    <div><button class="btn btn-warning fs14 me-2"  (click)="uploadFiles($event)" title="{{commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name}}">Upload a Different BOM</button><br>
                                                        <span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
                                                        <div class="ion-text-left fs15 mt5 pl5">
                                                        <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" style="position:relative;left:-20px;">Download custom BOM format</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <input type="file" id="fileInputOther" name="fileInputOther" style="display: none" accept=".xls,.xlsx"
                                          (change)="fileBrowseHandler($event)"
                                        />
                                        </div>
                                    </div>
                                    <div *ngIf="!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name" class="mt-2 mb-1 file-input-container form-control customize-input file-input" >
                                        <div class="styled-input" style="display: flex;cursor:pointer;" (click)="fileInput.click()">
                                          <div class="choose-file" >Choose file</div>
                                          <div class="upload-name" title="{{  curentFileUploadedName }}">{{  curentFileUploadedName || 'No file chosen' }}
                                            </div>
                                        </div>
                                        <input
                                          type="file"
                                          #fileInput
                                          style="display: none" accept=".xls,.xlsx"
                                          (change)="fileBrowseHandler($event)"
                                        />
                                    </div>
                                    <span *ngIf="!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name" style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
                                </div>
                                <div *ngIf="!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name" class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4  brd-label" style="text-align-last: end;">
                                    <label style="margin-right:5px;"><b>Number of Assemblies:</b></label>
                                </div>
                                <div class="col-4 ">
                                    <input class="form-control " name="numOfAssembs" id="numOfAssembs" type="number" [(ngModel)]="quoteDetailList.customNumOfAssemblies" />
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end;">
                                    <label style="margin-right: 5px;"><b>Assembly Turn-time:</b></label>
                                </div>
                                <div class="col-4 ">
                                    <select class="form-select" id="assembly-turn-time" [(ngModel)]="quoteDetailList.customaAssemblyTurnTime">
                                        <!-- <option value="1">1 day</option> -->
                                        <option value="2">2 days</option>
                                        <option value="3">3 days</option>
                                        <option value="4">4 Days</option>
                                        <option value="5">5 days</option>
                                        <option value="7">7 days</option>
                                        <option value="10">2 Weeks</option>
                                        <option value="15">3 Weeks</option>
                                        <option value="20">4 Weeks</option>
                                    </select>
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <!-- OFP-405  code -->
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end;">
                                    <label style="margin-right: 5px;"><b>Number of sides to be assembled</b></label>
                                </div>
                                <div class="col-4 ">
                                    <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch  " [ngClass]="(commonService.commonMainObj.assemblySides == '1 side' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.assemblySides == '' ? 'btn-green active' : 'btn-gray' " id="numberOfSidesOne" value="One side"/>
                                    <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="commonService.commonMainObj.assemblySides == '2 sides' && commonService.commonMainObj.greaterQtyResp ? 'btn-green active' : 'btn-gray' " id="numberOfSidesTwo" value="Two sides"/>
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end;">
                                    <label style="margin-right: 5px;"><b>Lead-free processing</b></label>
                                </div>
                                <div class="col-4 ">
                                    <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.leadFreeProcessing == 'Yes' && commonService.commonMainObj.greaterQtyResp) ? 'btn-green active' : 'btn-gray' " id="leadFreeYes" value="Yes" />
                                    <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.leadFreeProcessing == 'No' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.leadFreeProcessing == '' ? 'btn-green active' : 'btn-gray' " id="leadFreeNo" value="No"/>    
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="row justify-content-center">
                                <div class="col-4 brd-label" style="text-align-last: end;">
                                    <b>PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" href="{{apiService.Via_In_Pad_URL}}" target="_blank">Via-in-pad</a> features?</b>
                                </div>
                                <div class="col-4 ">
                                    <input type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.viaInPadData == 'Yes' && commonService.commonMainObj.greaterQtyResp) ? 'btn-green active' : 'btn-gray' " id="viaInPadsYes" value="Yes" (click)="switchOfAssmButtons($event)"/>
                                    <input type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.viaInPadData == 'No' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.viaInPadData == '' ? 'btn-green active' : 'btn-gray' " id="viaInPadsNo" value="No" (click)="switchOfAssmButtons($event)"/>
                                </div>
                                <div class="col-4">&nbsp;</div>
                            </div>
                        </div> 
                    </div>
                </div>
                
            </div>
        </div>
        <section class="container" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">
            <div style="display: flex;margin-top: 2rem;">
                <div class="plr-15 get-ass-txt">Want to Re-Quote?</div>
                <div class="btn-group2" id="re_quote">
                <input (click)="wantReQuote('reQuoteYes')" type="button" class="btn btn-switch btn-gray " id="reQuoteYes" value="Yes"/>
                <input (click)="wantReQuote('reQuoteNo')" type="button" class="btn btn-switch  btn-green active" id="reQuoteNo" value="No" />
                </div>
            </div>
        </section>
        <div *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB' && commonService.commonMainObj.reQuoteEnable"> 
            <div class="mt-4 mb-3">
                <div class=" col-6 offset-1 grey-border" style="padding: 6px 0;border-radius: 5px">
                    <div class="col-12 p-3 justify-content-center">
                        <div class="col-sm-12">
                            <div class="table-responsive">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th align="center" valign="middle">Line Item</th>
                                            <th align="center" valign="middle">Quantity</th>
                                            <th align="center" valign="middle">Turn Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><b>PCB Fabrication</b></td>
                                            <td><input type="text" class="form-control" [(ngModel)]=" newPcbQty" (keyup)="newPCBQtyChnge()"/></td>
                                            <td>
                                                <select class="form-select" [(ngModel)]="newPcbOrgTurnTime">
                                                    <option value="1 Day">1 Day</option>
                                                    <option value="2 Days">2 Days</option>
                                                    <option value="3 Days">3 Days</option>
                                                    <option value="4 Days">4 Days</option>
                                                    <option value="5 Days">5 Days</option>
                                                    <option value="2 Weeks">2 Weeks</option>
                                                    <option value="3 Weeks">3 Weeks</option>
                                                    <option value="4 Weeks">4 Weeks</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr *ngIf="commonService.commonMainObj.onlyPcb == false">
                                            <td><b>Assembly Labor</b></td>
                                            <td><input type="text" disabled class="form-control" [(ngModel)]="newAssemblyQty" readOnly="true"/></td>
                                            <td>
                                                <select class="form-select" [(ngModel)]="newAssemblyTurnTime">
                                                    <option value="1 Day">1 Day</option>
                                                    <option value="2 Days">2 Days</option>
                                                    <option value="3 Days">3 Days</option>
                                                    <option value="4 Days">4 Days</option>
                                                    <option value="5 Days">5 Days</option>
                                                    <option value="7 Days">7 Days</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <button type="button" class="btn btn-custom btn-warning px-xxl-5" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="reQuote(existingQuote)"> <b>Re-Quote </b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 text-center mb-4 mt-5">
            <button  *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && !commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp" type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="backToBoardDetails()"><b>Back</b></button>
            <button  *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && !commonService.commonMainObj.greaterQtyResp && !commonService.commonMainObj.reQuoteCheck" type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="backToComponentProcurement()"><b>Back</b></button>
            <button type="button" *ngIf="commonService.commonMainObj.isGuestUser == false && commonService.commonMainObj.customAssemblySelected != true" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> <b *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && commonService.commonMainObj.customAssemblySelected != true">Request for Custom Quote</b> <b *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</b>
            </button>
            <button type="button" *ngIf="commonService.commonMainObj.customAssemblySelected == true" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="bomProceed(autoMapping)"> <b *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Proceed</b>
            </button>
            <button type="button" *ngIf="commonService.commonMainObj.isGuestUser == true && commonService.commonMainObj.customAssemblySelected != true" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> <b *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && commonService.commonMainObj.customAssemblySelected != true">Request for Custom Quote</b> <b *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</b>
            </button>
            <button *ngIf="commonService.commonMainObj.isGuestUser == false && commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'" type="button" class="btn btn-custom btn-warning btn_forest_green_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click) = "placeOrder()"> <b>Place order </b>
            </button>
            <button *ngIf="commonService.commonMainObj.isGuestUser == true && commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'" type="button" class="btn btn-custom btn-warning btn_forest_green_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestOrderPlace('placeOrder')">
                <b>Place order </b>
            </button>
        </div>
    </div>
</div>
<ng-template #listOfSpecification let-modal class="auto-mapping-modal">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">List of PCB Specifications that do not qualify for our best price</h4>
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
    <div class="modal-body">
        <div *ngIf="!commonService.commonMainObj.greaterQtyResp" class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
            <ul>
                <li style="list-style-type: auto;padding-bottom: 2px" *ngFor="let item of commonService.commonMainObj.customQuoteParam | keyvalue">{{item.value}}</li>
            </ul>
            <div *ngIf="commonService.commonMainObj.noPriceForTurntimeQtyCombination == true">
            Turntime {{commonService.commonMainObj.selectedFabTurntime}} for quantity {{commonService.commonMainObj.selectedFabQuantity}}
            </div>
            <div *ngIf="commonService.commonMainObj.noPriceForAllTurntimeQtyCombination == true">
                Turntime  <span *ngFor="let mat of commonService.commonMainObj.priceMatrixColData; let indx = index" >{{commonService.commonMainObj.priceMatrixColData[indx].field}}<span *ngIf="indx < (commonService.commonMainObj.priceMatrixColData.length) - 1">, </span></span><span> for quantities </span> <span *ngFor="let element of commonService.commonMainObj.priceMatrixRowData; let indx2 = index">{{commonService.commonMainObj.priceMatrixRowData[indx2].turnTimeQuantity}}<span *ngIf="indx2 < (commonService.commonMainObj.priceMatrixRowData.length) - 1">, </span></span>
            </div>
        </div>
        <div *ngIf="commonService.commonMainObj.greaterQtyResp" class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
            <div *ngFor="let resp of greaterBomResponse; let indx3 = index">{{resp}}</div>
        </div>
    </div>
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('cancel click')"><b>Ok</b></button>
    </div>
  </ng-template>

<!-- FOR ASSEMBLY ERRORS -->
  <ng-template #assemblyErrorModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Assembly File Errors</h4>
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center text-danger">Please upload missing files to get assembly quote.</div>
      <!-- <button type="button" (click)="reValidate();"></button> -->
      <div>
        <div class="p-2 bg-warnings fw-b">Errors:</div>
        <div class="brd_warning">
          <ul class="list-type-number">
              <li *ngFor="let assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors; index as idx" style="display: flex;align-items: center;">
                <div style="width: 60%;">
                  {{idx+1}}. {{assmblyErr.error}} <span class="fa fa-info-circle m-2" title="{{assmblyErr.description}}"></span>
                </div>
                <label for="{{assmblyErr.errorCode}}" class="m-2 missing-file-lable">
                  <input type="file" class="missing-file-input" id="{{assmblyErr.errorCode}}" (change)="missingFilesHandel($event, ''+assmblyErr.errorCode)">
                  <i class="fa fa-cloud-upload"></i> Upload
                </label>
                <div>
                  <span id="{{assmblyErr.errorCode}}_name" class="file-color m-2"></span>
                  <span style="display: none;" class="delete-file" id="{{assmblyErr.errorCode}}_delete" (click)="deleteFile(''+assmblyErr.errorCode)"><i class="fa fa-solid fa-trash"></i></span>
                </div>
                
                <span id="{{assmblyErr.errorCode}}_error" class="error-message"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-danger btn-min-wt" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-warning btn-min-wt" id="assembly_error_proceed" [disabled]="disableAssemblyErrorProceed == true" (click)="reValidate()"><b>Proceed</b></button>
    </div>
  </ng-template>
  <ng-template #autoMapping let-modal class="auto-mapping-modal">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">BOM column mapping</h4>
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
    <div class="modal-body" *ngIf="showNumberOfSheets">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center mb-3"><b><u>Map the column headings for your BOM</u></b></div>
          <div class="text-center fs14 text-danger"> <b>Note: </b> Please select the column name for the mandatory columns that are not auto-mapped. If any of the mandatory columns are not present in the BOM, click on "Cancel" button and upload a new BOM that has all the mandatory columns.</div>
        </div>
      </div>
      <!-- Changes done based on OFP-652 -->
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        <div class="row justify-content-md-center" *ngFor="let cma of mainRowArrayObj['labelsArray'];let idx = index" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
          <div class="row justify-content-md-center"  *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">
            <div class="col-sm-3">
              <div>
                <label *ngIf="cma.labelType != 'new'">{{cma.labelName}}<span class="text-danger" *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">*</span></label>
              </div>
            </div>
            
            <div class="col-sm-4">
              <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" [ngClass]="cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number' ? 'requiredField' : 'notRequireField'" placeholder="Select" [(ngModel)]="cma.selectedName1" (change)="checkIfAllOptionsPresent()">
                  <option value="">Select</option>
                  <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj" *ngFor="let crow of mainRowArrayObj['bomOneMapArrayData']">
                    {{crow.labelValue}}
                  </option>
                </select>
            </div>
          </div>
        </div>
      </div>
  
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        <div class="row justify-content-md-center" *ngFor="let cma of mainRowArrayObj['labelsArray'];let idx = index" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
          <div class="row justify-content-md-center"  *ngIf="!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">
            <div class="col-sm-3">
              <div>
                <label *ngIf="cma.labelType != 'new'">{{cma.labelName}}<span class="text-danger" *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">*</span></label>
              </div>
            </div>
            
            <div class="col-sm-4">
              <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" placeholder="Select" [(ngModel)]="cma.selectedName1">
                  <option value="">Select</option>
                  <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj" *ngFor="let crow of mainRowArrayObj['bomOneMapArrayData']">
                    {{crow.labelValue}}
                  </option>
                </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body" *ngIf="!showNumberOfSheets">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center clr_green mb-5"><b>Your excel has multiple worksheets. Please specify worksheet that has BOM info.</b></div>
          <div class="row justify-content-md-center">
            <div class="col-sm-3">
                <label>Select Sheet: </label>
            </div>
            <div class="col-sm-4">
                <select class="form-control form-select mb-3" placeholder="Select" [(ngModel)]="selectedSheetNum">
                  <option value="">Select</option>
                  <option value="{{sheet.index}}" *ngFor="let sheet of sheetsArray">
                    {{sheet.name}}
                  </option>
                </select>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-center" style="display: block;" *ngIf="!showNumberOfSheets">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="proceedSheet()"><b>Proceed</b></button>
    </div>
    <div class="modal-footer text-center" style="display: block;" *ngIf="showNumberOfSheets">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" id="automap-modal-proceed-btn" (click)="proceedAutoMapData()" ><b>Proceed</b></button>
      <!-- (click)="modal.close('Save click')" [disabled]="disableAutomapProceed == true" OFP-613 -->
    </div>
    </ng-template>
    <ng-template #existingQuote let-modal>
        <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title"></h4>
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="modal-crose">×</span>
        </button>
        </div>
        <div class="modal-body">
            <!-- (click)="changeQuote()" -->
            <div class="p-3 m-3">You have already created a quote <b><a  class="text_deco_underline">{{newChangeQuoteId}}</a></b> for the given turntime and quantity. Please click on <b>Open Existing Quote</b> button; else, click on <b>‘Generate New Quote’</b> button to get a new quote </div>
            <div class="text-center">
                <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-1" (click)="generateQuote()"><b>Generate New Quote</b></button>
                <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-1" (click)="changeQuote()"><b>Open Existing Quote</b></button>
            </div>
        </div>
    </ng-template>
    
    <ng-template #unResolveLineItems let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Unresolved Line Items</h4>
            <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="modal-crose">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="col-sm-12" style="position: relative;">
                <div class="table-responsive table_height_auto" id="unResolveTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="quote-items-to-purchase" class="table table-bordered">
                        <thead class="bg-warning text-center">
                            <tr>
                                <th style="width: 2%;font-size: 14px;" align="center" valign="middle">Item Number</th>
                                <th style="width: 10%;font-size: 14px;" align="center" valign="middle">Manufacturer Part Number</th>
                                <th style="width: 15%;font-size: 14px;" align="center" valign="middle">Reference Designators</th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-issues">
                          <tr *ngFor="let issuesObj of commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.items; let in = index">
                            <td align="center" valign="top">{{issuesObj.itemNo}}</td>
                            <td align="center" valign="top">{{issuesObj.mpn}}</td>
                            <td align="center" valign="top">{{issuesObj.referenceDesignator}}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </ng-template>
<app-footer></app-footer>